"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gmailAddLabelToEmail = exports.gmailAddLabelToEmailResultSchema = exports.gmailAddLabelToEmailArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.gmailAddLabelToEmailArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('add-label-to-email', zod_1.z.object({
    message: zod_1.z.string().describe('The ID of the message to modify'),
    addLabelIds: zod_1.z.array(zod_1.z.string()).describe('List of label IDs to add'),
    removeLabelIds: zod_1.z.array(zod_1.z.string()).describe('List of label IDs to remove'),
}));
exports.gmailAddLabelToEmailResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.object({
    id: zod_1.z.string().describe('The immutable ID of this message'),
    threadId: zod_1.z.string().describe('The ID of the thread the message belongs to'),
    labelIds: zod_1.z.array(zod_1.z.string()).describe('List of label IDs applied to this message'),
    snippet: zod_1.z.string().nullish().describe('A short part of the message text'),
}));
exports.gmailAddLabelToEmail = (0, common_1.createEmitModeToolMetadata)({
    id: 'gmailAddLabelToEmail',
    displayName: 'Gmail Add Label to Email',
    displayDescription: 'Add label(s) to an email message in Gmail',
    category: 'communication',
    color: common_1.BRAND_COLORS.GMAIL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GMAIL),
    icon: 'gmail',
    argsSchema: exports.gmailAddLabelToEmailArgsSchema,
}, exports.gmailAddLabelToEmailResultSchema);
